import { render, staticRenderFns } from "./OrgsIndex.vue?vue&type=template&id=35240ebd"
import script from "./OrgsIndex.vue?vue&type=script&lang=js"
export * from "./OrgsIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports